import { createFileRoute } from '@tanstack/react-router'

import { userFilters } from '@/features/users/filters'
import { UsersList } from '@/features/users/users-list'

export const Route = createFileRoute('/_app/users/')({
    // Every list filter lives in the URL, so a view is shareable and survives a
    // refresh. `parse` never throws: a hand-edited URL degrades to the defaults.
    validateSearch: userFilters.parse,
    component: UsersList,
    staticData: { crumb: 'Users' }
})
